import {IEvaluatorOptions} from "./i-evaluator-options";
import {TS} from "../../type/ts";

/**
 * Evaluates, or attempts to evaluate, a OmittedExpression
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function evaluateOmittedExpression(_options: IEvaluatorOptions<TS.OmittedExpression>): undefined {
	return undefined;
}
